import React from 'react';
import { Grid } from '@material-ui/core';

import Title from 'components/typography/Title';
import Protected from 'components/Protected';
import RecipesListLoading from 'components/recipes/list/RecipesListLoading';

import EmptyRecipes from './EmptyRecipes';
import useBookmarksPage from './useBookmarksPage';
import RecipesList from 'components/recipes/list/RecipesList';

const BookmarksPage = () => {
  const {
    bookmarkedRecipes,
    isLoading,
    hasAnyRecipe,
    hasFinished,
  } = useBookmarksPage();

  return (
    <Grid container direction="column" spacing={4}>
      <Grid item container>
        <Title>Bookmarked Recipes</Title>
      </Grid>

      <Grid item container>
        <Protected justify="flex-start">
          <Grid item container>
            {hasFinished && !hasAnyRecipe && <EmptyRecipes></EmptyRecipes>}

            {hasFinished && hasAnyRecipe && (
              <RecipesList recipes={bookmarkedRecipes}></RecipesList>
            )}

            {isLoading && <RecipesListLoading count={4}></RecipesListLoading>}
          </Grid>
        </Protected>
      </Grid>
    </Grid>
  );
};

export default BookmarksPage;
